import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_home_decor_pillows: FaireCategoryEntity = {
  token: "cat_home-decor-pillows",
  type: "category",
  name: "Throw pillows & blankets",
  level: 2,
  parentToken: "cat_home-decor",
  href: "/category/home-decor/throw-pillows-blankets",
  childCategoryTokens: [
    "cat_pillows-all",
    "cat_pillows-blankets",
    "cat_pillows-pillows",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
